import { Link } from "react-router-dom";


const Tools = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Link to="/tools/qfflightfinder" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-10 px-20 rounded text-center">
                    QF Flight Finder
                </Link>
                <Link to="/tools/qfwine" className="bg-purple-500 hover:bg-purple-700 text-white font-bold py-10 px-20 rounded text-center">
                    QF Wine Tracker
                </Link>
            </div>
        </div>
    )
}

  
export default Tools;